import React, { useState, useEffect, useReducer } from 'react'
import { Flex } from 'reflexbox/styled-components'
import { toast } from 'react-toastify'
import { useHistory } from 'react-router-dom'

import Loader from 'components/Loader'
import TextButton from 'components/TextButton'
import SimpleListingTable from 'components/SimpleListingTable'
import { Edit } from 'components/Icons'

import { reducer as loadingReducer } from 'helpers/loadingReducer'
import { getPackages } from 'services/packages'

import theme from 'styles/theme'
import { formatCurrency } from 'utils/formatters'

const tableColumns = [
  {
    Header: 'Pacote',
    accessor: 'name',
  },
  {
    Header: 'Slug',
    accessor: 'slug',
  },
  {
    Header: 'External ID',
    accessor: 'external_id',
  },
  {
    Header: 'Preço',
    accessor: 'current_partner_price',
  },
  {
    Header: 'Ações',
    accessor: 'actions',
  },
]

const PackagesList = () => {
  const [packages, setPackages] = useState([])
  const [requestStatus, dispatch] = useReducer(loadingReducer, { isLoading: true, error: false })

  const history = useHistory()

  useEffect(() => {
    const fetchPackages = async () => {
      try {
        const { data } = await getPackages()

        const packages = data.map(({ id, name, slug, external_id, current_partner_price }) => ({
          id,
          name,
          slug,
          external_id,
          current_partner_price: current_partner_price ? formatCurrency(current_partner_price.value) : '-',
          actions: (
            <TextButton
              variant='custom'
              color={theme.colors.grays.N600}
              onClick={() => history.push(`/staff/prepaid-partners/packages/${id}`)}
            >
              <Edit /> Editar
            </TextButton>
          ),
        }))

        setPackages(packages)
        dispatch({ type: 'success' })
      } catch (err) {
        console.log(err)
        dispatch({ type: 'error' })
        toast.error('Não foi possível carregar os beneficiários no momento')
      }
    }

    fetchPackages()
  }, [])

  return (
    <Flex width={1} flexDirection='column'>
      <Flex width={1} justifyContent='space-between' alignItems='center'>
        <h1>Pacotes</h1>
      </Flex>

      {requestStatus.isLoading ? <Loader /> : <SimpleListingTable columns={tableColumns} data={packages} />}
    </Flex>
  )
}

export default PackagesList
